export const POPULAR_SEARCH_HEADING = 'Popular Searches';
export const POPULAR_SEARCH_TAGS = [
  'Clubbing Outfits',
  'Clean Girl Aesthetic',
  'Y2K Revival',
  'Corset Tops',
  'Cargo Skirts',
  'Sheer Dresses',
  'Dinner Date Ideas',
  'Summer Shirt',
] as const;
export const RIGHT_ARROW_SIZE = 18;
